import React, { useEffect, useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { DialogContent, Typography, List, ListItem, ListItemButton, Divider, ModalClose, Tooltip, ListItemDecorator, Modal, ModalDialog, useColorScheme } from '@mui/joy';
import {
    Box,
    Button,
    IconButton,
    Stack,
    Select,
    Option,
    Avatar,
    Drawer,
    Dropdown,
    Menu,
    Chip,
    MenuItem,
    MenuButton,
    DialogTitle,
    Card
} from '@mui/joy';
import { Menu as MenuIcon, Add as AddChat, Person as UserIcon, Logout as LogoutIcon, Settings as SettingsIcon, Explore, Close as CloseIcon, Newspaper, MoreHoriz, DeleteForever, Star, Money, Payments, Support, ShoppingBag, Add, Dns, Share, CopyAll, Check, Download, Downloading, DarkMode, LightMode } from '@mui/icons-material';
import { useAuth, logout } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Blub from '../img/bulb.png';
import { useLanguage } from '../LanguageProvider';
import { createInvoice } from './CreateInvoice';
import { FiDownload } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import { Transition } from 'react-transition-group';
import { getApiUrl } from '../utils/api';

const isRussianDomain = window.location.hostname === 'chat.acceptancegroup.org'

const AnimatedIcon = ({ open }) => (
    <AnimatePresence mode="wait">
        {open ? (
            <motion.span
                key="close"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.15 }}
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <CloseIcon />
            </motion.span>
        ) : (
            <motion.span
                key="menu"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.15 }}
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <MenuIcon />
            </motion.span>
        )}
    </AnimatePresence>
);

function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

function Header({ CapricornVersion, onChangeCapricornVersion, currentPage, openNews, customModel }) {
    const { user, loading, checkRateLimit } = useAuth();
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { mode, setMode } = useColorScheme();

    const { currentLanguageData, language } = useLanguage();

    const [openMenu, setOpenMenu] = useState(false);
    const [options, setOptions] = useState([]);

    const defaultOptions = [
        { value: '4', name: 'Capricorn Flash (4.0)' },
        { value: '4.1', name: 'Capricorn Vision (4.1)' },
        { value: '4.3', name: 'Capricorn Bixbite (4.3)' },
        { value: '4.4', name: 'Capricorn Taaffeite (4.4b)', disabled: checkRateLimit.characters !== Infinity}
    ];

    const handleDownload = () => {
        const os = getMobileOperatingSystem();

        if (os === "Android") {
            //window.open("https://play.google.com/store/apps/details?id=your.app.id", "_blank");
        } else if (os === "iOS") {
            //window.open("https://apps.apple.com/app/your-app-name/id123456789", "_blank");
        } else {
            window.open("https://screwltd.com/capricorn/Setup.exe", "_blank");
        }
    };

    const [selectedVersion, setSelectedVersion] = useState(() => {
        const defaultOptionValues = defaultOptions.map(option => option.value);

        if (defaultOptionValues.includes(CapricornVersion)) {
            return CapricornVersion;
        } else {
            localStorage.setItem("version", defaultOptions[0].value)
            onChangeCapricornVersion(defaultOptions[0].value);
            return defaultOptions[0].value;
        }
    });

    const [enterpriseOpen, setEnterpriseOpen] = React.useState(false);
    const [shareOpen, setShareOpen] = React.useState(false);
    const [shareChat, setShareChat] = React.useState(null);

    const [copied, setCopied] = useState(false);
    useEffect(() => {
        if (copied) {
            const timer = setTimeout(() => {
                setCopied(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [copied]);

    const handleEnterpriseClose = () => {
        localStorage.setItem('enterprice', true);
        setEnterpriseOpen(false);
    }

    useEffect(() => {
        const showEnterprice = () => {
            if (user.ai?.smart?.type == "Enterprise") {
                setEnterpriseOpen(!localStorage.getItem('enterprice'));
            }
        }

        showEnterprice();
    }, []);

    function handleRefreshChat() {
        setOpenMenu(false);
        const newUrl = `/chat?id=${generateGUID()}`;
        navigate(newUrl);
        fetchChats();
    }

    function handleOpenSupport() {
        setOpenMenu(false);
        const newUrl = `/chat?id=${generateGUID()}&model=@support`;
        navigate(newUrl);
        fetchChats();
    }

    function openUrl(url) {
        setOpenMenu(false);
        navigate(url);
    }

    function openChat(id, model = null) {
        let newUrl = `/chat?id=${id}`;
        if (model) {
            newUrl += `&model=${encodeURIComponent(model)}`;
        }
        setOpenMenu(false);
        navigate(newUrl);
        fetchChats();
    }

    const handleChangeVer = (event, newValue) => {
        onChangeCapricornVersion(newValue);
    };

    const [chats, setChats] = useState([]);
    const [modelNames, setModelNames] = useState({});

    const fetchModel = async (model) => {
        try {
            if(model == undefined)
            {
                return null;
            }
            
            const response = await fetch(getApiUrl(`/v3/ai/model/${model}`));
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.name;
        } catch (error) {
            console.error('Error fetching model name:', error);
            return null;
        }
    };

    const handleDelete = async (chatId) => {
        setChats((prevChats) => prevChats.filter(chat => chat.chatId !== chatId));

        try {
            const response = await fetch(getApiUrl(`/v3/ai/chat/delete/${chatId}`), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.jwt_token}`,
                },
            });

            const result = await response.json();

            if (!response.ok) {
                console.error('Error:', result.error);
            }
        } catch (error) {
            console.error('Server error:', error);
        }
    };

    const handleFavorite = async (chatId, favorite) => {
        setChats((prevChats) =>
            prevChats.map((chat) =>
                chat.chatId === chatId ? { ...chat, favorite: favorite } : chat
            )
        );

        try {
            const response = await fetch(getApiUrl(`/v3/ai/chats/favorite/${chatId}`), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${user.jwt_token}`,
                },
                body: JSON.stringify({ favorite }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Error updating favorite:', errorData);
                return { success: false, error: errorData.error };
            }

            const data = await response.json();
            console.log('Favorite state updated successfully:', data);
            return { success: true, data };
        } catch (error) {
            console.error('Network error:', error);
            return { success: false, error: 'Network error' };
        }
    };

    const fetchChats = async () => {
        try {
            const response = await fetch(getApiUrl('/v3/ai/chats/history'), {
                headers: {
                    Authorization: `Bearer ${user.jwt_token}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch chats');
            }

            const data = await response.json();

            if (JSON.stringify(chats) === JSON.stringify(data.chats)) {
                return;
            }

            setChats(data.chats);

            const uniqueModels = [...new Set(data.chats.map(chat => chat.model))];

            const modelNamesMap = {};
            await Promise.all(
                uniqueModels.map(async (model) => {
                    modelNamesMap[model] = await fetchModel(model);
                })
            );

            const updatedModelNames = data.chats.reduce((acc, chat) => {
                acc[chat.chatId] = modelNamesMap[chat.model];
                return acc;
            }, {});

            setModelNames(updatedModelNames);
        } catch (error) {
            console.error('Error fetching chats:', error);
        }
    };

    useEffect(() => {
        const intervalId = setInterval(fetchChats, 10000);
        fetchChats();
        return () => clearInterval(intervalId);
    }, [loading]);


    useEffect(() => {
        if (customModel) {

            setOptions([{
                value: customModel.model,
                name: customModel.name,
                disabled: false
            }]);
            setSelectedVersion(customModel.model);
        } else {
            setOptions(defaultOptions);
            setSelectedVersion(CapricornVersion);
        }
    }, [customModel, CapricornVersion]);

    useEffect(() => {
        if (customModel && options.length > 0) {
            setSelectedVersion(options[0].value);
        }
    }, [options, customModel]);

    const groupChatsByDate = (chats) => {
        const groupedChats = {};

        chats.forEach(chat => {
            const date = new Date(chat.createdAt);
            const today = new Date();

            let dateKey;
            if (date.toDateString() === today.toDateString()) {
                dateKey = currentLanguageData.today;
            } else if (date.toDateString() === new Date(today.setDate(today.getDate() - 1)).toDateString()) {
                dateKey = currentLanguageData.yesterday;
            } else {
                dateKey = date.toLocaleDateString(language, { month: 'long', day: 'numeric' });
            }

            if (!groupedChats[dateKey]) {
                groupedChats[dateKey] = [];
            }

            groupedChats[dateKey].push(chat);
        });

        return groupedChats;
    };

    const toggleColorMode = () => {
        setMode(mode === 'light' ? 'dark' : 'light');
    };

    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    width: '100%',
                    backgroundColor: theme.palette.header.main,
                    zIndex: 9001,
                }}
            >
                <div style={{
                    padding: '16px',
                    display: 'flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                    <Stack direction='row'>
                        <IconButton sx={{ borderRadius: 50 }} onClick={() => setOpenMenu(!openMenu)}>
                            <AnimatedIcon open={openMenu} />
                        </IconButton>
                        <Select
                            sx={{ backgroundColor: theme.palette.header.main, borderRadius: 18 }}
                            value={selectedVersion}
                            onChange={handleChangeVer}
                            variant='plain'
                            defaultValue={CapricornVersion}
                        >
                            {options.length > 0 ? options.map(option => (
                                <Option key={option.value} value={option.value} disabled={option.disabled}>
                                    {(window.__TAURI_INTERNALS__ || isMobile) ? option.name.replace("Capricorn ", "") : option.name}
                                </Option>
                            )) : defaultOptions.map(option => (
                                <Option disabled={option.disabled} key={option.value} value={option.value}>
                                    {(window.__TAURI_INTERNALS__ || isMobile) ? option.name.replace("Capricorn ", "") : option.name}
                                </Option>
                            ))}
                        </Select>
                    </Stack >
                    <Box>
                        <Stack direction='row' spacing={1.5}>
                            <Stack direction='row' spacing={1}>
                                {!window.__TAURI_INTERNALS__ && true == false && (<IconButton onClick={() => handleDownload()} sx={{ borderRadius: '50%', width: 40, height: 40 }}><Downloading /></IconButton>)}
                                {!isMobile && (
                                    <IconButton sx={{ borderRadius: '50%', width: 40, height: 40 }} onClick={() => openNews(true)}><Newspaper /></IconButton>
                                )}
                                <IconButton onClick={toggleColorMode} sx={{ borderRadius: '50%', width: 40, height: 40 }}>
                                    {mode === 'light' ? <DarkMode /> : <LightMode />}
                                </IconButton>
                            </Stack>
                            <Dropdown>
                                <MenuButton variant='plain' sx={{ p: 0, borderRadius: '50%' }}>
                                    <Avatar src={user ? user.avatar : ''} />
                                </MenuButton>
                                <Menu sx={{ zIndex: 9900 }} variant='plain'>
                                    {!window.__TAURI_INTERNALS__ && <MenuItem onClick={() => window.open(isRussianDomain ? `https://account.acceptancegroup.org/?token=${user.jwt_token}` : `https://account.screwltd.com/?token=${user.jwt_token}`, '_blank')}><UserIcon />{currentLanguageData.account}</MenuItem>}
                                   {/* 
                                    {user.ai?.smart?.type == "Enterprise" && (<MenuItem onClick={() => navigate('/servers')}><Dns />{currentLanguageData.servers}</MenuItem>)}
                                    {user.role != "User" && (<MenuItem onClick={() => navigate('/income')}><Payments />{currentLanguageData.monetization}</MenuItem>)}
                                   */}
                                    {(user.role === "Admin" || user.role === "Owner") && (<MenuItem onClick={() => navigate('/orders')}><ShoppingBag />{currentLanguageData.orders}</MenuItem>)}
                                    <MenuItem onClick={() => navigate('/settings')}><SettingsIcon />{currentLanguageData.setting}</MenuItem>
                                    <MenuItem onClick={() => logout()}><LogoutIcon />{currentLanguageData.logout}</MenuItem>
                                </Menu>
                            </Dropdown>
                        </Stack>
                    </Box>
                </div>
            </Box >
            <Drawer
                open={openMenu}
                size={'md'}
                onClose={() => setOpenMenu(false)}
                sx={{
                    zIndex: 9000,
                    '--Drawer-transitionDuration': openMenu ? '0.4s' : '0.2s',
                    '--Drawer-transitionFunction': openMenu
                        ? 'cubic-bezier(0.79,0.14,0.15,0.86)'
                        : 'cubic-bezier(0.77,0,0.18,1)',
                }}
            >
                <DialogContent sx={{ px: 1, py: 0, scrollbarWidth: 'none', pt: (window.__TAURI_INTERNALS__ && !isMobile) ? '102px' : '72px', backgroundColor: theme.palette.header.main }}>
                    <Box sx={{ mb: 2 }}>
                        <Button onClick={() => { navigate('/explore'); setOpenMenu(false); }} variant='plain' color="neutral" sx={{ width: '100%', justifyContent: 'start', borderRadius: 50 }} startDecorator={<Explore />}>{currentLanguageData.exploreAi}</Button>
                        <Button onClick={() => handleRefreshChat()} variant='plain' color="neutral" sx={{ width: '100%', justifyContent: 'start', borderRadius: 50 }} startDecorator={<AddChat />}>{currentLanguageData.newChat}</Button>
                        {/* 
                        <Button disabled variant='plain' color="neutral" sx={{ width: '100%', justifyContent: 'start', borderRadius: 50 }} startDecorator={<PersonAddAlt1 />}>{currentLanguageData.createGroup}</Button>
                        */}
                        <Button disabled variant='plain' color="neutral" sx={{ width: '100%', justifyContent: 'start', borderRadius: 50 }} startDecorator={<ShoppingBag />}>{currentLanguageData.shop}</Button>
                        <Button onClick={() => handleOpenSupport()} variant='plain' color="neutral" sx={{ width: '100%', justifyContent: 'start', borderRadius: 50 }} startDecorator={<Support />}>{currentLanguageData.support}</Button>
                        <Box sx={{ marginTop: 1, marginBottom: 1 }} />
                        <List sx={{ paddingBottom: 22 }}> {/* LEFT TO 22 */}
                            {chats.length === 0 ? (
                                <Typography sx={{ paddingX: 2, paddingTop: 0, paddingBottom: 0 }}>{currentLanguageData.nochats}</Typography>
                            ) : (
                                <>
                                    {chats.filter(chat => chat.favorite).length > 0 && (
                                        <>
                                            <Typography
                                                level="title-sm"
                                                sx={{ paddingX: 1, paddingTop: 1, opacity: 1, color: 'purple' }}
                                            >
                                                {currentLanguageData.favoriteTitle}
                                            </Typography>
                                            {chats.filter(chat => chat.favorite).map(chat => (
                                                <ListItem key={chat.chatId}>
                                                    <ListItemButton
                                                        onClick={() =>
                                                            openChat(chat.chatId, chat.model ? chat.model : null)
                                                        }
                                                        sx={{
                                                            p: 0.5,
                                                            px: 1,
                                                            borderRadius: 50,
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            mr: 0.5,
                                                        }}
                                                    >
                                                        <Typography noWrap>
                                                            {modelNames[chat.chatId] ? (
                                                                <span>
                                                                    <Chip
                                                                        sx={{ pr: 1, backgroundColor: "#6a1b9a80" }}
                                                                    >
                                                                        {modelNames[chat.chatId]}
                                                                    </Chip>
                                                                    &nbsp;
                                                                </span>
                                                            ) : chat.model ? (
                                                                <span>
                                                                    <Chip>...</Chip>&nbsp;
                                                                </span>
                                                            ) : null}
                                                            {chat.firstMessage}
                                                        </Typography>
                                                    </ListItemButton>
                                                    <Dropdown>
                                                        <MenuButton
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            variant="plain"
                                                            sx={{
                                                                pointerEvents: "auto",
                                                                p: 0,
                                                                height: "24px",
                                                                width: "24px",
                                                                minWidth: "24px",
                                                                pointerEvents: "auto",
                                                                zIndex: 1,
                                                                minHeight: "24px",
                                                                borderRadius: "50%",
                                                            }}
                                                        >
                                                            <MoreHoriz />
                                                        </MenuButton>
                                                        <Menu
                                                            sx={{ zIndex: 99990, borderRadius: 12, py: 0 }}
                                                            variant="plain"
                                                        >
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleFavorite(chat.chatId, false);
                                                                }}
                                                                color="warning"
                                                            >
                                                                <ListItemDecorator sx={{ color: "inherit" }}>
                                                                    <Star />
                                                                </ListItemDecorator>{" "}
                                                                {currentLanguageData.unfavorite}
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setShareChat(chat);
                                                                    setShareOpen(true);
                                                                    setOpenMenu(false);
                                                                }}
                                                                color="neutral"
                                                            >
                                                                <ListItemDecorator sx={{ color: "inherit" }}>
                                                                    <Share />
                                                                </ListItemDecorator>{" "}
                                                                {currentLanguageData.share}
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDelete(chat.chatId);
                                                                }}
                                                                color="danger"
                                                            >
                                                                <ListItemDecorator sx={{ color: "inherit" }}>
                                                                    <DeleteForever />
                                                                </ListItemDecorator>{" "}
                                                                {currentLanguageData.delete}
                                                            </MenuItem>
                                                        </Menu>
                                                    </Dropdown>
                                                </ListItem>
                                            ))}
                                            <Box sx={{ mt: 1, opacity: 0.3 }} />
                                        </>
                                    )}

                                    {Object.entries(
                                        groupChatsByDate(chats.filter(chat => !chat.favorite))
                                    ).map(([dateKey, groupedChats], index, array) => (
                                        <React.Fragment key={dateKey}>
                                            <Typography
                                                level="title-sm"
                                                sx={{ paddingX: 1, paddingTop: 1, opacity: 0.4 }}
                                            >
                                                {dateKey}
                                            </Typography>
                                            {groupedChats.map((chat) => (
                                                <ListItem key={chat.chatId}>
                                                    <ListItemButton
                                                        onClick={() =>
                                                            openChat(chat.chatId, chat.model ? chat.model : null)
                                                        }
                                                        sx={{
                                                            p: 0.5,
                                                            px: 1,
                                                            borderRadius: 50,
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            mr: 0.5,
                                                        }}
                                                    >
                                                        <Typography noWrap>
                                                            {modelNames[chat.chatId] ? (
                                                                <span>
                                                                    <Chip
                                                                        sx={{ pr: 1, backgroundColor: "#6a1b9a80" }}
                                                                    >
                                                                        {modelNames[chat.chatId]}
                                                                    </Chip>
                                                                    &nbsp;
                                                                </span>
                                                            ) : chat.model ? (
                                                                <span>
                                                                    <Chip>...</Chip>&nbsp;
                                                                </span>
                                                            ) : null}
                                                            {chat.firstMessage}
                                                        </Typography>
                                                    </ListItemButton>
                                                    <Dropdown>
                                                        <MenuButton
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            variant="plain"
                                                            sx={{
                                                                pointerEvents: "auto",
                                                                p: 0,
                                                                height: "24px",
                                                                width: "24px",
                                                                minWidth: "24px",
                                                                pointerEvents: "auto",
                                                                zIndex: 1,
                                                                minHeight: "24px",
                                                                borderRadius: "50%",
                                                            }}
                                                        >
                                                            <MoreHoriz />
                                                        </MenuButton>
                                                        <Menu
                                                            sx={{ zIndex: 99990, borderRadius: 12, py: 0 }}
                                                            variant="plain"
                                                        >
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleFavorite(chat.chatId, true);
                                                                }}
                                                                color="warning"
                                                            >
                                                                <ListItemDecorator sx={{ color: "inherit" }}>
                                                                    <Star />
                                                                </ListItemDecorator>{" "}
                                                                {currentLanguageData.favorite}
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setShareChat(chat);
                                                                    setShareOpen(true);
                                                                    setOpenMenu(false);
                                                                }}
                                                                color="neutral"
                                                            >
                                                                <ListItemDecorator sx={{ color: "inherit" }}>
                                                                    <Share />
                                                                </ListItemDecorator>{" "}
                                                                {currentLanguageData.share}
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDelete(chat.chatId);
                                                                }}
                                                                color="danger"
                                                            >
                                                                <ListItemDecorator sx={{ color: "inherit" }}>
                                                                    <DeleteForever />
                                                                </ListItemDecorator>{" "}
                                                                {currentLanguageData.delete}
                                                            </MenuItem>
                                                        </Menu>
                                                    </Dropdown>
                                                </ListItem>
                                            ))}
                                            {index < array.length - 1 && <Box sx={{ mt: 1, opacity: 0.3 }} />}
                                        </React.Fragment>
                                    ))}
                                </>
                            )}
                        </List>
                    </Box>
                    <Card
                            variant='soft'
                            color="warning"
                            sx={{
                                position: 'fixed',
                                bottom: 10,
                                left: 10,
                                right: 10,
                                padding: 2,
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                                zIndex: 999999,
                                borderRadius: 20
                            }}>
                            <Typography level='title-md' sx={{ mb: -1 }}>{currentLanguageData.advancedDesc}</Typography>
                            <Typography level='body-sm'><span dangerouslySetInnerHTML={{ __html: currentLanguageData.smartMiniText }} /></Typography>
                            <Button onClick={() => { navigate('/plans'); setOpenMenu(false); }} color="warning" sx={{ borderRadius: 30, py: 2 }} variant="solid">{currentLanguageData.getStarted}</Button>
                            <img style={{ pointerEvents: 'none', opacity: 0.3, position: 'absolute', right: 6, bottom: -24, height: '110%', objectFit: 'cover' }} src={Blub} />
                        </Card>
                </DialogContent>
            </Drawer>

            <Modal open={enterpriseOpen}>
                <ModalDialog sx={{ borderRadius: 20, maxHeight: '60%', backgroundColor: theme.palette.header.main }} variant="plain">
                    <DialogTitle>Capricorn Enterprise</DialogTitle>
                    <DialogContent sx={{ scrollbarWidth: 'none' }}>
                        <div style={{ marginBottom: 10 }} dangerouslySetInnerHTML={{ __html: currentLanguageData.thxEnterprise }} />
                        <Box>
                            <Button onClick={() => handleEnterpriseClose()} startDecorator={<Add />} sx={{ borderRadius: 250 }} variant='soft'>{currentLanguageData.newChat}</Button>
                        </Box>
                    </DialogContent>
                </ModalDialog>
            </Modal>

            <Transition in={shareOpen} timeout={400}>
                {(state) => (
                    <Modal
                        keepMounted
                        open={!['exited', 'exiting'].includes(state)}
                        onClose={() => setShareOpen(false)}
                        slotProps={{
                            backdrop: {
                                sx: {
                                    opacity: 0,
                                    backdropFilter: 'none',
                                    transition: `opacity 400ms, backdrop-filter 400ms`,
                                    ...{
                                        entering: { opacity: 1, backdropFilter: 'blur(8px)' },
                                        entered: { opacity: 1, backdropFilter: 'blur(8px)' },
                                    }[state],
                                },
                            },
                        }}
                        sx={{
                            zIndex: 10000,
                            visibility: state === 'exited' ? 'hidden' : 'visible',
                        }}
                    >
                        <ModalDialog
                            layout='center'
                            variant="plain"
                            sx={{
                                opacity: 0,
                                borderRadius: 20,
                                transition: `opacity 300ms`,
                                ...{
                                    entering: { opacity: 1 },
                                    entered: { opacity: 1 },
                                }[state],
                            }}
                        >
                            <DialogTitle>{currentLanguageData.share} {shareChat?.firstMessage.slice(0, shareChat?.firstMessage.length - 1)}?</DialogTitle>
                            <ModalClose onClick={() => setShareOpen(false)} sx={{ borderRadius: 250 }} />
                            <DialogContent sx={{ scrollbarWidth: 'none' }}>
                                <Stack spacing={2}>
                                    <Typography>{currentLanguageData.shareText1}<br />{currentLanguageData.shareText2}<br />{currentLanguageData.shareText3}</Typography>
                                    <Box>
                                        <Button onClick={() => { navigator.clipboard.writeText(`https://chat.screwltd.com/chat?id=${shareChat?.chatId}${shareChat?.model ? `&model=${shareChat?.model}` : ''}&share=${shareChat?.shareCode}`); setCopied(true); }} variant='soft' startDecorator={copied ? <Check /> : <CopyAll />} sx={{ borderRadius: 20 }}>{copied ? currentLanguageData.shareCopied : currentLanguageData.shareCopy}</Button>
                                    </Box>
                                </Stack>
                            </DialogContent>
                        </ModalDialog>
                    </Modal>
                )}
            </Transition >
        </>
    );
}

export default Header;
